<template>
  <div class="dropdown-container">
    <v-btn icon @mouseenter="handle" @mouseleave="hideTooltip">
      <v-icon v-if="!customIcon">fa-solid fa-filter</v-icon>
      <img v-else :src="customPath" alt="" srcset="">
      <slot name="customBtn"></slot>

    </v-btn>
    <transition name="dropdown-content">
      <div v-if="active" class="content absolute" ref="tooltipContent">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    customIcon: {
      type: Boolean,
      default: false,
    },
    iconPath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    customPath() {
      if (!this.customIcon) {
        return '';
      }
      return require(`@/assets/img/${this.iconPath}`);
    },
  },
  methods: {
    handle() {
      this.active = true;
      this.$nextTick(() => {
        const tooltip = this.$refs.tooltipContent;
        if (!tooltip) return;
        const rect = tooltip.getBoundingClientRect();
        if (rect.bottom > window.innerHeight) {
          tooltip.style.bottom = '100%';
          tooltip.style.top = 'auto';
        } else {
          tooltip.style.top = '100%';
          tooltip.style.bottom = 'auto';
        }
      });
    },
    hideTooltip() {
      this.active = false;
    },
  },
}
</script>

<style scoped>
.dropdown-container {
  position: relative;
  display: inline-block;
}

.dropdown-content-enter-active,
.dropdown-content-leave-active {
  transition: all 0.2s;
}

.dropdown-content-enter,
.dropdown-content-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.absolute {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}

.content {
  z-index: 100;
  background-color: bisque;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 6px;
  box-shadow: 0px 0px 15px -2px #9e9e9e;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: max-content;
  min-width: 160px;
  font-size: 16px;
  padding: 10px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/global/Tooltip.vue